// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"025a9090","239":"856afe96","453":"bfd3837d","455":"d6280960"}[chunkId] + ".chunk.js";
};